import React from 'react';
import { IconProps } from '@sharefiledev/flow-web';
import { CheckBoxCheckedIcon } from '../../../assets/icons';
import {
	Component,
	ComponentTypes,
	defaultCheckBoxAnnotationIconSize,
	defaultComponentDimensions,
	Field,
} from '../../../common/componentUtils';
import SignatureAnnotation from './SignatureAnnotation/SignatureAnnotation';
import TextAnnotationComponent from './TextAnnotationComponent';

export interface Props {
	component: Component;
	field: Field;
	width: number;
	height: number;
	handleComponentUpdate: (components: Component[], nextState?: string) => void;
	setComponentsToEdit: (comp: Component[]) => void;
	componentsToEdit: Component[];
	textAnnotationZIndex: number;
	updateTextAnnotationZIndex: (newIndex: number) => void;
	scale: number;
}

export const Annotation = ({
	component,
	field,
	width,
	height,
	handleComponentUpdate,
	setComponentsToEdit,
	componentsToEdit,
	textAnnotationZIndex,
	updateTextAnnotationZIndex,
	scale,
}: Props) => {
	if (field.type === ComponentTypes.CheckmarkAnnotationComponent) {
		const Icon: React.FC<IconProps> = CheckBoxCheckedIcon;
		return (
			<Icon
				size={
					(width * defaultCheckBoxAnnotationIconSize) /
					defaultComponentDimensions.CheckmarkAnnotationComponent.width
				}
				// optionColor={fromThemeColors(ThemeColor.primaryText)({ theme: {} })}
				data-testid="checkbox-icon"
			/>
		);
	} else if (field.type === ComponentTypes.SignatureAnnotationComponent) {
		return <SignatureAnnotation component={component} width={width} height={height} />;
	} else if (field.type === ComponentTypes.TextAnnotationComponent) {
		return (
			<div
				style={{ transform: `scale(${scale})`, position: 'absolute', left: 0, top: 0 }}
			>
				<TextAnnotationComponent
					component={component}
					handleComponentUpdate={handleComponentUpdate}
					setComponentsToEdit={setComponentsToEdit}
					componentsToEdit={componentsToEdit}
					textAnnotationZIndex={textAnnotationZIndex}
					updateTextAnnotationZIndex={updateTextAnnotationZIndex}
				/>
			</div>
		);
	}
	return null;
};

export default Annotation;
